/**
 * Centralized configuration for frontend application
 *
 * In development: Uses proxy (empty string = relative URLs get proxied by dev server)
 * In production: Uses REACT_APP_API_URL env var or constructs api subdomain URL
 */

function getApiUrl() {
  // Development: use relative path (proxied by dev server to http://backend:8000)
  if (process.env.NODE_ENV === "development") {
    return ""; // Empty string = same origin, Create React App dev server proxies to backend
  }

  // Production: use env var if set
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Production fallback: construct API URL using api subdomain
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  return `${protocol}//api.${hostname}`;
}

export const API_URL = getApiUrl();
